



























import { Vue, Component } from 'vue-property-decorator';
import { Getter, Action, Mutation, State } from 'vuex-class';
import ConnectDatabase from '../components/ConnectDatabase.vue';
import DatabaseModals from './DatabaseModals.vue';
import TableRecords from './TableRecords.vue';
import TableMeta from './TableMeta.vue';
import { DatabaseModuleState } from '../store/modules/database/types';
const namespace: string = 'database';

@Component({
  components: {
    ConnectDatabase,
    TableRecords,
    TableMeta,
    DatabaseModals,
  },
})
export default class Main extends Vue {
  public $notify: any;
  private activeTab: string = 'records';
  @Getter private currentDb!: string;
  @Getter private currentTable!: string;
  @Getter private response!: { message: string; title: string; type: string };
  @Getter private loading!: boolean;
  @Mutation private notified: any;
  @State(namespace) private database!: DatabaseModuleState;
  @Action('submitRemoteForm', { namespace }) private submitRemoteForm: any;
  @Action('submitLocalForm', { namespace }) private submitLocalForm: any;
  @Action('loadProfiles', { namespace }) private loadProfiles!: () => Promise<void>;
  @Action private getCurrentProfile!: (name: string) => Promise<void>;
  @Mutation('setToDefault', { namespace }) private setToDefault: any;
  @Mutation('setSelectedProfile', { namespace }) private setSelectedProfile!: (name: string) => void;

  private get isDesktop() {
    return !!window.electronAPI;
  }

  private connectProfile() {
    this.database.selectedProfile && this.getCurrentProfile(this.database.selectedProfile);
  }
  private updated() {
    if (this.response.message) {
      this.$notify({
        title: this.response.title,
        message: this.response.message,
        type: this.response.type,
        duration: 3000,
      });
      this.notified();
    }
  }
}
